import React, { useEffect, useState } from 'react';
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Html from './Html';
import environment from '../../../environment';
import ApiClient from '../../../methods/api/apiClient';
import { Routes } from '../../../methods/ApiRoutes';
import { login_success } from '../../../actions/user';

function Sidebar({ isOpen }) {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const [role, setRole] = useState(user.customerRole);
  const menus = {
    user: ['roles', 'users'],
    catalogue: ['types', 'categories', 'category/'],
    plan: ['features', 'plans'],
    api: ['bookingSystem', 'pos', 'reviews', 'accountingSystem'],
    geo: ['continents', 'countries', 'regions', 'cities'],
    dynamicPricing: ['dynamicprice'],
    skills: ['skills', 'skill-roles'],
  };

  function ListItemLink({
    to, type = 'link', disabled = false, ...rest
  }) {
    let url = window.location.href;
    const { host } = window.location;
    url = url.split(host)[1];
    return (
      <>
        {type == 'link' ? (
          <li
            className={`nav-item ${url.includes(to) ? 'active' : ''} ${disabled ? 'disabled' : ''
              }`}
          >
            {/* {...rest} */}
            <Link to={to} {...rest} className="" />
          </li>
        ) : (
          <li
            className={`nav-item main ${url.includes(to) ? 'active' : ''}`}
            {...rest}
          />
        )}
      </>
    );
  }

  const tabclass = (tab) => {
    const url = window.location.href;
    let value = false;
    menus[tab]?.map((itm) => {
      if (url.includes(itm)) value = true;
    });
    return value;
  };

  const isAllow = (url = '') => {
    const permissions = user?.permissions?.[0];
    const arr = url.split(',');
    let value = false;
    arr.map((itm) => {
      if (permissions?.[itm]) value = permissions?.[itm];
    });

    if (!url || user?.role?.name == 'admin') value = true;
    return value;
  };

  const route = (p) => {
    history(p);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (user?._id) {
      ApiClient.get(Routes.User.detailApi, { id: user?._id || user?.id }).then(Res => {
        if (Res.success) {
          dispatch(login_success(Res?.data))
        }
      })
    }
  }, [])
  return (
    <Html
      user={user}
      route={route}
      tabclass={tabclass}
      isAllow={isAllow}
      ListItemLink={ListItemLink}
      isOpen={isOpen}
    />
  );
}

export default Sidebar;
